export const getCheckInStatus = async (creditHistory, eventId) => {
  return creditHistory.some((credit) => credit.id === eventId);
};